import {
  type DashboardActions,
  InternalMembersActions,
} from '@store/reducers/dashboard/actions'
import { GeneralErrorNotification } from '@storeOld/reducers/notification'
import { call, put } from 'redux-saga/effects'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { NestClient } from '@/nest'

export function* changeRole({
  payload,
}: ReturnType<typeof DashboardActions.members.changeRole>) {
  const { workspaceId, id, role } = payload
  yield put(InternalMembersActions.update(payload))
  try {
    yield call(NestClient.membership.changeRole, workspaceId, id, { role })
    yield call(
      sendGtmEvent,
      role === 'MANAGER'
        ? GtmTriggerName.TEAM_MEMBER_MAKE_MANAGER
        : GtmTriggerName.TEAM_MEMBER_MAKE_MEMBER
    )
  } catch (e) {
    console.error('Error while changing member role', e)
    yield put(GeneralErrorNotification)
  }
  yield put(InternalMembersActions.fetchList({ workspaceId }))
}
